import { Alert, Platform, AlertOptions, AlertButton } from 'react-native'

type AlertFunc = (
  title: string,
  message?: string | undefined,
  buttons?: AlertButton[] | undefined,
  options?: AlertOptions | undefined
) => void

const alertPolyfill: AlertFunc = (title, message, buttons = [], options) => {
  if (buttons?.length <= 1) {
    window.alert([title, message].filter(Boolean).join('\n'))
    if (buttons.length) {
      buttons[0]?.onPress?.()
    }

    return
  }

  const result = window.confirm([title, message].filter(Boolean).join('\n'))

  if (result) {
    const confirmOption = buttons?.find(({ style }: { style?: string }) => style !== 'cancel')
    confirmOption && confirmOption?.onPress?.()
  } else {
    const cancelOption = buttons?.find(({ style }: { style?: string }) => style === 'cancel')
    cancelOption && cancelOption?.onPress?.()
  }
}

export const alert = Platform.OS === 'web' ? alertPolyfill : Alert.alert
